import React from 'react';
import './button.scss';
import PublicIcon from '@mui/icons-material/Public';
import '../header/Header.scss';
import i18next from 'i18next'
import { useDispatch } from "react-redux";
import {
    setActiveLanguage,
} from "../../slices/vehicleSlice";
import { useNavigate } from "react-router-dom";

const LanguagePanel = ({ getDefaultLanguage, getSupportedLanguages, activeLocale, setDefaultLng, vehicleCodes,exterirorColorCode }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const currentUrl = window.location.pathname;
    const codes = [];

    if (Array.isArray(vehicleCodes)) {
        vehicleCodes.forEach((code) => {
            codes.push({code: code})
        })
    }

    dispatch(setActiveLanguage(activeLocale))
    i18next.changeLanguage(activeLocale);

    function changeLanguage(event) {
        let lng = event.target.value;
        if (!lng) {
            lng = getDefaultLanguage;
        }

        i18next.changeLanguage(lng);
        setDefaultLng(lng);
        dispatch(setActiveLanguage(lng));

        const buttons = document.querySelectorAll('.language-btn');
        buttons.forEach((button) => {
            if (button.value === lng) {
                button.classList.add('active');
            } else {
                button.classList.remove('active');
            }
        });

        const lang = lng.substr(0, 2);
        let newUrl = currentUrl.replace(new RegExp(`/${lang}/`, "g"), '/');
        newUrl = newUrl.replace(/\/{2,}/g, '/');

        if (['fr', 'es'].includes(lang)) {
            if (newUrl.includes('/vehicle')) {
                newUrl = newUrl.replace('/vehicle', `/${lang}/vehicle`);
            } else if (newUrl.includes('/compare')){
                newUrl = newUrl.replace('/compare',`/${lang}/compare`)
            }
            navigate(newUrl);
        } else if (lang === 'en' || lang === '') {
            if (newUrl.includes('/compare/')) {
                newUrl = newUrl.replace(/\/(fr|es|en)?\/compare/, '/compare');
            }
            newUrl = newUrl.replace(/\/(fr|es|en)?\/vehicle/, '/vehicle');
            navigate(newUrl);
        }
    }

    function getLanguage(lang) {
        return lang.substr(0, 2).toUpperCase();
    }

    return (
        <React.Fragment>
            <div className={'languageSelectionTab'}>
                {getSupportedLanguages.map((lang,index) => (
                    <React.Fragment key={lang}>
                        <button
                            value={lang}
                            className={activeLocale === lang ? 'language-btn btn-active-lang' : 'language-btn'}
                            onClick={(e) => changeLanguage(e)}>
                            {getSupportedLanguages.length > 1 ? getLanguage(lang) : null}
                        </button>
                        {
                            index === 0 && getSupportedLanguages.length > 1 &&
                            <span className={'language-separator'}> {" | "}</span> }
                    </React.Fragment>
                ))}
                {getSupportedLanguages.length > 1 && < PublicIcon className={'languageIcon'} fontSize={'small'} />}
            </div>
        </React.Fragment>
    );
};

export default LanguagePanel;